module.exports = __webpack_public_path__ + "static/media/ic_pa_b5_fisdom.5290d1ba.svg";